import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FilterPanel } from '@gsa/afp-component-library';
import { useFederalStandards } from '../../../fvs-provider';

const {
  FilterPanelField,
  FilterPanelFilterShape,
} = FilterPanel;

const SELECT_VEHICLE_GROUP = { label: 'Select vehicle group', value: '' };

const VehicleGroupFilterItem = ({ filter }) => {
  const { clearOneFilter, setFilters, currentFilters } = FilterPanel.useFilterPanel();
  const {
    vehicleClassificationOptions,
  } = useFederalStandards();

  // currentFilters is authoritative; getFilterFromState lags a render behind.
  const valueInState = (key) =>
    currentFilters?.filters?.find((f) => f.key === key)?.value || '';

  const fedStandardCode = valueInState('fedStandardCode');
  const vehicleGroup = valueInState(filter.key);

  const options = useMemo(() => {
    if (!fedStandardCode || !vehicleClassificationOptions?.vehicleGroup) {
      return [SELECT_VEHICLE_GROUP];
    }

    // only groups under the selected federal standard code
    const filteredGroups = vehicleClassificationOptions.vehicleGroup
      .filter((vGroup) => vGroup.parent === fedStandardCode)
      .map((vGroup) => ({
        label: vGroup.label,
        value: vGroup.value,
      }));

    return [SELECT_VEHICLE_GROUP, ...filteredGroups];
  }, [fedStandardCode, vehicleClassificationOptions]);

  // stale once it no longer sits under the selected federal standard code
  const isStale =
    Boolean(vehicleGroup) &&
    !options.some((option) => option.value === vehicleGroup);

  // the panel can overwrite a clear while syncing to the url, so re-assert it
  useEffect(() => {
    if (isStale) {
      clearOneFilter(filter);
    }
  }, [isStale, currentFilters?.filters]);

  useEffect(() => {
    setFilters({
      type: 'updateOptions',
      filter: {
        ...filter,
        options,
      },
    });
  }, [options]);

  return (
    <div className="margin-top-3">
      <label htmlFor={filter.key} className="usa-label">
        {filter.title}
      </label>
      <FilterPanelField
        key={[filter.key]}
        filter={{
          ...filter,
          type: 'select',
          options,
        }}
      />
    </div>
  );
};

VehicleGroupFilterItem.propTypes = {
  filter: PropTypes.shape(FilterPanelFilterShape).isRequired,
};

export default VehicleGroupFilterItem;
